module.exports = __webpack_public_path__ + "img/iconanalytics.e32cbb50.png";